import { ChangeDetectorRef, Component, HostListener, Inject, ViewChild, DestroyRef, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { MatStepper } from '@angular/material/stepper'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModeloDocumentoService } from './modelo-documento.service'

@Component({
  selector: 'app-modelo-stepper-dialog',
  templateUrl: './modelo-stepper-dialog.component.html',
  styleUrls: ['./modelo-stepper-dialog.component.scss'],
})
export class ModeloStepperDialogComponent {
  private destroyRef = inject(DestroyRef)
  @ViewChild('stepper') stepper!: MatStepper

  pdfBlob: Blob | null = null
  loading = false
  loadingDocx = false
  downloaded = false
  formData: Record<string, string> = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { concursoId: number; tipo: string },
    public dialogRef: MatDialogRef<ModeloStepperDialogComponent>,
    private service: ModeloDocumentoService,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    if (this.pdfBlob && !this.downloaded) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  onFormReady(campos: Record<string, string>): void {
    this.formData = campos
  }

  onStepChange(event: { selectedIndex: number }): void {
    if (event.selectedIndex === 2) {
      this.dialogRef.updateSize('90vw', 'auto')
    } else {
      this.dialogRef.updateSize('90vw', '90vh')
    }
  }

  formValido(): boolean {
    if (!this.formData['dataDocumento']) return false
    if ('_recursosValidos' in this.formData && this.formData['_recursosValidos'] !== 'true') return false
    return true
  }

  gerarPreview(): void {
    this.loading = true
    const { _recursosValidos, ...campos } = this.formData
    this.service.gerarPdf(this.data.concursoId, this.data.tipo, campos)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: blob => {
          this.pdfBlob = blob
          this.cdr.detectChanges()
          this.stepper.next()
        },
        error: (err) => {
          this.loading = false
          this.mostrarErro(err, 'Erro ao gerar pré-visualização. Tente novamente.')
        },
        complete: () => this.loading = false,
      })
  }

  download(): void {
    if (!this.pdfBlob) return
    const url = URL.createObjectURL(this.pdfBlob)
    const a = document.createElement('a')
    a.href = url
    a.download = this.data.tipo.toLowerCase().replace(/_/g, '-') + '.pdf'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    this.downloaded = true
    this.cdr.detectChanges()
    this.stepper.next()
  }

  downloadDocx(): void {
    this.loadingDocx = true
    const { _recursosValidos, ...campos } = this.formData
    this.service.gerarDocx(this.data.concursoId, this.data.tipo, campos)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: blob => {
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = this.data.tipo.toLowerCase().replace(/_/g, '-') + '.docx'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(url)
          this.downloaded = true
          this.cdr.detectChanges()
          this.stepper.next()
        },
        error: (err) => {
          this.loadingDocx = false
          this.mostrarErro(err, 'Erro ao gerar arquivo Word. Tente baixar em PDF.')
        },
        complete: () => this.loadingDocx = false,
      })
  }

  private mostrarErro(err: any, fallbackMsg: string): void {
    if (err?.error instanceof Blob) {
      const reader = new FileReader()
      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result as string)
          this.snackBar.open(json.message || fallbackMsg, 'Fechar', { duration: 8000 })
        } catch {
          this.snackBar.open(fallbackMsg, 'Fechar', { duration: 8000 })
        }
      }
      reader.readAsText(err.error)
    } else {
      const msg = err?.error?.message || fallbackMsg
      this.snackBar.open(msg, 'Fechar', { duration: 8000 })
    }
  }
}
